import { api } from '../index';

// #3252 : State 조회 권한 관리. beautyplus 관리자만 호출한다.
// 다른 회사는 서버가 404 로 끝내므로 화면에서도 이 API 를 부르지 않는다.
const prefix = '/api/basic_info/state_access/';

export function apiSelectStateAccessList(param) {
	return api.post(prefix + 'list', param);
}

export function apiSelectStateAccessCandidates(param) {
	return api.post(prefix + 'candidates', param);
}

export function apiSaveStateAccessGrant(param) {
	return api.post(prefix + 'save', param);
}

export function apiDeleteStateAccessGrant(param) {
	return api.post(prefix + 'delete', param);
}

export function apiChangeStateAccessMode(param) {
	return api.post(prefix + 'mode', param);
}
